import { Box, BoxProps } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

interface ContainerStyledProps {
  active: boolean;
  border?: boolean;
}
const hoverBackgroundColor = 'rgba(#fff, 0.12)';

export const ContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  flexDirection: { sm: 'column' },
})<BoxProps & ContainerStyledProps>`
  position: relative;
  ${({ theme, active, border }) => css`
    width: ${theme.componentStyles.navBarWidth};
    height: 60px;
    background-color: ${active && hoverBackgroundColor};
    border-left: ${active ? `2px solid ${theme.colors.white}` : `2px solid transparent`};
    border: ${border && `1px dashed ${theme.colors.white}`};

    &::before {
      content: '';
      position: absolute;
      background: ${theme.colors.white};
      opacity: 0.12;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: ${active ? 'block' : 'none'};
      top: 0;
      left: 0;
    }
    &:hover {
      &::before {
        content: '';
        position: absolute;
        background: ${theme.colors.white};
        opacity: 0.12;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: block;
        top: 0;
        left: 0;
      }
    }
  `}
`;

export const IconWrapperStyled = styled(Box).attrs({
  mb: { sm: '400' },
})`
  height: 20px;
  width: 20px;
  margin-left: auto;
  margin-right: auto;

  & path:not([data-name='Code (Book) Icon']) {
    fill: white;
  }
`;

export const MoreOptionsLinkStyled = styled(NavLink)`
  position: relative;
  ${({ theme }) => css`
    background-color: transparent;
    width: ${theme.componentStyles.navBarWidth};
    height: 60px;
    align-items: center;
    cursor: pointer;
    box-shadow: none;

    &:hover::before {
      content: '';
      position: absolute;
      background-color: ${hoverBackgroundColor};
      width: 100%;
      height: 100%;
      z-index: 1;
      display: block;
      top: 0;
      left: 0;
    }
  `}
`;
